/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { DataMergeService } from './datamerge.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { extend } from 'webdriver-js-extender';
import { appConfig } from '../app.config';

/**
 * add credential to allow having the backend on a different url than the front end
 * cookies are shared with the backend to track session.
 */
@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(private dataMergeService: DataMergeService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    for (let url of appConfig.interceptorsExcludeUrls) {
      if (request.url.startsWith(url)) {
        return next.handle(request);
      }
    }
    const credentialsReq = request.clone({ withCredentials: true });
    return next.handle(credentialsReq).pipe(map((x) => this.handleHttpResponseEvent(x)));
  }
  private handleHttpResponseEvent(responseEvent: HttpEvent<any>): any {
    if (responseEvent.type !== HttpEventType.Response) {
      return responseEvent;
    }
    responseEvent = responseEvent.clone({ body: this.parseResponse(responseEvent.body) });
    return responseEvent;
  }
  private parseResponse(data: any): any {
    const result = this.dataMergeService.parseData(data);
    return result;
  }
}
